import { render, staticRenderFns } from "./generalInterpretation.vue?vue&type=template&id=5d17fd0c&scoped=true"
import script from "./generalInterpretation.vue?vue&type=script&lang=js"
export * from "./generalInterpretation.vue?vue&type=script&lang=js"
import style0 from "./generalInterpretation.vue?vue&type=style&index=0&id=5d17fd0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d17fd0c",
  null
  
)

export default component.exports